// defaultState is the expected initial state when feeding values in.
// reducers are reducers with names matching the keys to be used in the
// final state.
const combineReducersWithGlobal = (defaultState, reducers) => {
  const reducerKeys = Object.keys(reducers);
  return (inputState = defaultState, action, prevGlobalState) => {
    // At the very top level, this will be called with only state and action
    // In that case, we need to copy across the domain state into the global state
    // as they are one and the same.
    const passGlobalState = prevGlobalState ? prevGlobalState : inputState;

    return inputState.withMutations(s => {
      reducerKeys.forEach(reducerName => {
        const reducer = reducers[reducerName];
        const prevDomainState = inputState.get(reducerName);
        const nextDomainState = reducer(prevDomainState, action, passGlobalState);
        s.set(reducerName, nextDomainState);
      });
    });
  };
};

export default combineReducersWithGlobal;
